<template>
  <div class="p-10">
    <h3 class="m-0 mb-10">基本信息</h3>
    <el-descriptions :column="2" label-class-name="font-bold font-14">
      <el-descriptions-item v-for="(item, key) in descriptionsConfig" :key="key" :label="item.label" content-class-name="font-14">
        <span v-if="item.renderHtml" v-html="item.renderHtml()" />
        <span v-else>{{ item.format ? item.format() : item.value }}</span>
      </el-descriptions-item>
    </el-descriptions>
    <h3 class="m-0 mt-20 mb-10">提交详情</h3>
    <app-table
      ref="app-table"
      :is-current-page="false"
      :page-size="2000"
      :table-key="tableKey"
      :table-list-data="tableData"
    />
  </div>
</template>

<script>
export default {
  components: {
    'app-table': () => import('@/components/app-table'),
  },
  props: {
    // 描述列表配置
    descriptionsConfig: {
      type: Object,
      required: true,
    },
    // 表头数据
    tableKey: {
      type: Array,
      required: true,
    },
    // 表格数据
    tableData: {
      type: Array,
      required: true,
    },
  },
};
</script>
